// src/components/common/OpportunityNameLink.jsx
import React, { useState } from 'react';
import { useOpportunityModal } from '../../contexts/OpportunityModalContext';

/**
 * Renders an opportunity name as a subtle clickable link.
 * Turns teal + underline on hover.
 *
 * Props:
 *   opportunity — object with at minimum { opportunity_id } or { name }
 *   children    — override display text (defaults to opportunity.name)
 *   style       — additional inline styles
 */
const OpportunityNameLink = ({ opportunity, children, style = {} }) => {
  const { openOpportunityModal } = useOpportunityModal();
  const [hovered, setHovered] = useState(false);

  const isClickable = !!(opportunity?.opportunity_id || opportunity?.name);

  const handleClick = (e) => {
    e.stopPropagation();
    if (isClickable) openOpportunityModal(opportunity);
  };

  const displayName = children ?? opportunity?.name ?? opportunity?.opportunity_name ?? 'Opportunity';

  if (!isClickable) return <span style={style}>{displayName}</span>;

  return (
    <span
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        color: hovered ? '#03DAC6' : 'inherit',
        textDecoration: hovered ? 'underline' : 'none',
        ...style,
      }}
    >
      {displayName}
    </span>
  );
};

export default OpportunityNameLink;
